import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { HomeOutlined } from "@ant-design/icons";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black px-4">
      <div className="text-center max-w-md">
        <img
          src="/assets/icons/IthnainLogoLight.svg"
          alt="Ithnain Logo"
          className="mx-auto mb-6 h-14 w-auto opacity-90"
        />
        <div className="mb-4">
          <span className="text-7xl sm:text-8xl font-bold text-white/10 tracking-tighter select-none">
            404
          </span>
        </div>
        <h1 className="text-xl sm:text-2xl font-semibold text-white mb-2">
          Page not found
        </h1>
        <p className="text-gray-400 text-base mb-8">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <Button
          type="primary"
          size="large"
          icon={<HomeOutlined />}
          onClick={() => navigate("/", { replace: true })}
          className="!bg-[#042C43] hover:!bg-[#053a52] !border-0 !h-12 !px-8 !rounded-lg !font-medium"
        >
          Back to home
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
